/**
 * Market API service
 */
import api from './api';

export const marketApi = {
  /** Estimate purchase/resale prices for a vehicle */
  estimate: (body) =>
    api.post('/market/estimate', body).then(r => r.data),

  /** Get demand trends by dimension */
  getDemandTrends: (params = {}) =>
    api.get('/market/demand', { params }).then(r => r.data),

  /** Get trending vehicles */
  getTrending: (params = {}) =>
    api.get('/market/trending', { params }).then(r => r.data),

  /** Get profitability analysis by dimension */
  getProfitability: (params = {}) =>
    api.get('/market/profitability', { params }).then(r => r.data),

  /** Get global profitability summary */
  getProfitabilitySummary: () =>
    api.get('/market/profitability/summary').then(r => r.data),
};
